export default "__VITE_ASSET__6867881c__"